import React from 'react'

export const IconList = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
    <path
      d="M5.33398 4H14.0007"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.33398 8H14.0007"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.33398 12H14.0007"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M2 4H2.00667" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M2 8H2.00667" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M2 12H2.00667" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)
